<template>
  <!-- No afecta el layout -->
  <div style="display:none" aria-hidden="true"></div>
</template>

<script>
function getTabHost(el) {
  if (!el || !el.closest) return null;
  // Vuetify 2: v-tabs-items / v-window envuelve cada panel en .v-window-item
  return el.closest(".v-window-item") || null;
}

function isTabActive(host) {
  if (!host) return true;

  const ariaHidden = host.getAttribute("aria-hidden");
  // Vuetify 2: tab activo = v-window-item--active y aria-hidden != true
  return host.classList.contains("v-window-item--active") && ariaHidden !== "true";
}

export default {
  name: "TabActiveSignal",
  props: {
    enabled: { type: Boolean, default: true },
    // emite estado al montar
    emitOnMount: { type: Boolean, default: true },
  },
  data() {
    return {
      _host: null,
      _mo: null,
      _lastActive: null,
    };
  },
  methods: {
    _emitIfChanged() {
      if (!this.enabled) return;

      const active = isTabActive(this._host);
      if (active === this._lastActive) return;

      this._lastActive = active;
      this.$emit("active-changed", active);
      this.$emit(active ? "activated" : "deactivated");
    },
  },
  watch: {
    enabled() {
      this.$nextTick(() => this._emitIfChanged());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this._host = getTabHost(this.$el);

      if (this.emitOnMount) this._emitIfChanged();

      // Si no estamos dentro de v-tabs-items, no hay host que observar
      if (!this._host) return;

      this._mo = new MutationObserver(() => this._emitIfChanged());
      this._mo.observe(this._host, {
        attributes: true,
        attributeFilter: ["class", "aria-hidden", "style"],
      });
    });
  },
  beforeDestroy() {
    if (this._mo) {
      this._mo.disconnect();
      this._mo = null;
    }
  },
};
</script>
